import axios, { config } from '..';
import {
  FETCH_ARTIST_SUCCESS,
  FETCH_ARTIST_FAILED,
  CLEAR_ARTIST,
  CLEAR_ADD_SET,
  CLEAR_UPDATE_ARTIST,
} from '../../actionTypes';

export default (id) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ARTIST });
    dispatch({ type: CLEAR_ADD_SET });
    dispatch({ type: CLEAR_UPDATE_ARTIST });

    const response = await axios.get(`/providers/artists/${id}`, config);

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: FETCH_ARTIST_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: FETCH_ARTIST_FAILED, error });
  }
};
